import { render, staticRenderFns } from "./MainNavigationContainer.vue?vue&type=template&id=066ad6ba&scoped=true&"
import script from "./MainNavigationContainer.vue?vue&type=script&lang=js&"
export * from "./MainNavigationContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066ad6ba",
  null
  
)

export default component.exports